export default __webpack_public_path__ + "static/media/PlaceHolderLogo.a73ea454.png";